/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useCallback, useEffect } from 'react'
import s from './GeneralSettings.module.css'

export function GeneralSettings({ id, onClose }) {
  const [inProgress, setInProgress] = useState(false)
  const [collectionName, setCollectionName] = useState('')
  const [collectionNote, setCollectionNote] = useState('')

  const handleDelete = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const response = await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })

      const data = await response.json()
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
      onClose()
    }
  }, [onClose])

  const handleArchive = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const response = await fetch(`/api/v3/listing_collections/${id}/archive`, {
        headers: {
          'API_TOKEN': apiToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'PUT',
      })

      const data = await response.json()
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
      onClose()
    }
  }, [onClose])

  useEffect(() => {
    async function getCollectionDetails() {
      try {
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${id} `, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })

        const data = await response.json()

        if (data.name) {
          setCollectionName(data.name)
        }

        if (data.description) {
          setCollectionNote(data.description)
        }

        // eslint-disable-next-line no-console
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }

    getCollectionDetails()
  }, [id])

  const handleUpdateGeneralSettings = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const formData = new FormData()

      formData.append('listing_collection[name]', collectionName)
      formData.append('listing_collection[description]', collectionNote)

      const response = await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          API_TOKEN: apiToken,
        },
        method: 'PUT',
        body: formData,
      })

      const data = await response.json()
      // eslint-disable-next-line no-console
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
    }
  }, [collectionName, collectionNote])

  return (
    <div className={s.root}>
      <div className={s.title}>General Settings</div>

      <label className={s.label} htmlFor="name">
        Collection Name
      </label>
      <input
        className={s.input}
        type="text"
        id="name"
        value={collectionName}
        autoComplete="off"
        onChange={(e) => {
          const { value } = e.target
          setCollectionName(value)
        }}
      />

      <label className={s.label} htmlFor="note">
        Notes <span className={s.optional}>(optional)</span>
      </label>
      <textarea
        name="note"
        className={s.textarea}
        rows={4}
        value={collectionNote}
        onChange={(e) => {
          const { value } = e.target
          setCollectionNote(value)
        }}
      />

      <div className={s.controls}>
        <button type="button" className={s.update} disabled={inProgress} onClick={handleUpdateGeneralSettings}>
          {inProgress ? 'Updating...' : 'Update'}
        </button>

        <div className={s.archiveAndDelete}>
          <div className={s.archive} onClick={handleArchive}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_13_510)">
                <path
                  d="M13.5556 13H2.46125C2.33902 12.9997 2.22189 12.951 2.13546 12.8645C2.04903 12.7781 2.00033 12.661 2 12.5387V5H13.5C13.6326 5 13.7598 5.05268 13.8536 5.14645C13.9473 5.24021 14 5.36739 14 5.5V12.5556C14 12.6735 13.9532 12.7865 13.8698 12.8698C13.7865 12.9532 13.6735 13 13.5556 13Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 5V3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H5.79313C5.92556 3.00006 6.05255 3.05266 6.14625 3.14625L8 5"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_13_510">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Archive
          </div>
          <div className={s.delete} onClick={handleDelete}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_13_538)">
                <path d="M13.5 3.5H2.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.5 6.5V10.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.5 6.5V10.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M12.5 3.5V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V3.5"
                  stroke="#FF8585"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.5 3.5V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H6.5C6.23478 1.5 5.98043 1.60536 5.79289 1.79289C5.60536 1.98043 5.5 2.23478 5.5 2.5V3.5"
                  stroke="#FF8585"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_13_538">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Delete
          </div>
        </div>
      </div>
    </div>
  )
}
